import { Provider } from '@angular/core';
import { PaginatedStateLoadingMode } from '@shared/ui';
import { rolesStoreProviders } from '@telespot/authentication/ui';
import {
  affiliatedUserStoreProviders,
  userMembershipsStoreProviders,
  workspaceStoreProviders,
} from '../../../providers/store.providers';
import { UserCreatorFacade } from './user-creator.facade';

/**
 * Providers for UserCreatorFacade and its dependencies.
 * Composes store providers with the facade.
 */
export function userCreatorFacadeProviders(): Provider[] {
  return [
    ...affiliatedUserStoreProviders(),
    ...userMembershipsStoreProviders(),
    ...rolesStoreProviders(),
    ...workspaceStoreProviders(PaginatedStateLoadingMode.CONTINUOUS),
    UserCreatorFacade,
  ];
}
